module.exports = __webpack_public_path__ + "img/Grappe_8.asset.b0dce824.svg";